module.exports = __webpack_public_path__ + "img/standard-shipping.cd27e76d.svg";